// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/browser/templates/browser.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("fcff29"),
    marko_node0 = marko_createElement("div", {
        "class": "browser"
      }, "0", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "controls"
        }, null, null, 1)
        .e("div", {
            "class": "control-panel"
          }, null, null, 1)
          .e("div", {
              "class": "control-group"
            }, null, null, 1)
            .e("div", {
                "class": "control"
              }, null, null, 1)
              .e("button", {
                  id: "songs"
                }, null, null, 1)
                .t("Songs")
      .e("div", {
          "class": "item-list"
        }, null, null, 0);

function render(input, out, __component, component, state) {
  var data = input;

  out.n(marko_node0, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
